import { useState, useEffect, useContext, useRef } from 'react';
import PageContext from '../sub-components/PageContext';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import PageInputRedux from '../sub-components/PageInputReduxTooltopCopy.jsx';
import { HttpContext } from '../../api-services/HttpService';
import { AuthContext } from '../../auth/AuthRoute';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import statusFilter from '../functions/statusFilter';
import standardSearch from '../functions/standardSearch';
import applyFilters from '../functions/applyFilters';
import UploadContractRow from '../sub-components/UploadContractRow'; 
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import ContractUploadCommentModal from '../sub-components/ContractUploadCommentModal'; 
import EditUploadClientContractModal from '../sub-components/EditUploadClientContractModal'; 
import AddClientContractSearchIdModal from '../sub-components/AddClientContractSearchIdModal'; 
// import EntitledButton from '../sub-components/EntitledButton'; 
import afterPeriodFilter from '../functions/afterPeriodFilter';
import beforePeriodFilter from '../functions/beforePeriodFilter';
import MonthPicker from '../sub-components/MonthPickerCopy.jsx'; 
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import PageDropdownBasic from '../sub-components/PageDropdownCopy.jsx';

const SearchClientContractPage = () => {
    // initialize http context 
    const {
        GET, 
    } = useContext(HttpContext);
    // initialize auth context
    const {
        getAdmin,
        getDataTech,
    } = useContext(AuthContext); 
    // initialize redux persisent state for search 
    const contractSearch = useSelector((state) => state.contractSearch);
    const dispatch = useDispatch();
    const { 
        setContractSearch, 
    } = bindActionCreators(actionCreators, dispatch);
    // intiailize state
    const [clientContractDataList, setClientContractDataList] = useState([]); 
    const [showClientContractDataList, setShowClientContractDataList] = useState([]);
    const [clientContractTableHeader, setClientContractTableHeader] = useState([]); 
    const [triggerFilter, setTriggerFilter] = useState(false); 
    const [showSpinner, setShowSpinner] = useState(false); 
    const defaultCheckboxDropdownState = 'Active';
    const [showInactiveContracts, setShowInactiveContracts] = useState(defaultCheckboxDropdownState); 
    const [uploadClientContractModal, setUploadClientContractModal] = useState(false);
    const [showContractCommentModal, setShowContractCommentModal] = useState(false); 
    const [showEditContractModal, setShowEditContractModal] = useState(false); 
    const [contractUploadRow, setContractUploadRow] = useState({}); 
    const [masterCompanyList, setMasterCompanyList] = useState([]); 
    const [editButtonBool, setEditButtonBool] = useState(false); 
    const [startPeriodId, setStartPeriodId] = useState(null); 
    const [endPeriodId, setEndPeriodId] = useState(null); 
    // initialize snackbar state
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    const [enableReset, setEnableReset] = useState(false);
    const [contractTypeList] = useState(['All','Active','Inactive']);
    

    // initialize refs
    const initialRender = useRef(true); 

    // function wrapper to pass row component to datatable 
    const UploadContractRowComponent = (row, count, tableHeader) => {
        return (
            <>
                <UploadContractRow row={row} count={count} tableHeader={tableHeader} enableEdit={row['edit']} />
            </>
        );
    }

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // initial get request to get all data for page
    const getClientContractData = () => {
        return new Promise((resolve, reject) => {
            // show spinner
            setShowSpinner(showSpinner => showSpinner = true); 
            // use function to make http request
            GET('/data/searchClientContractsPage', {}).then(res => {
                // set table state
                setClientContractDataList(clientContractDataList => clientContractDataList = res['data']['UploadContractsData']); 
                setShowClientContractDataList(showClientContractDataList => showClientContractDataList = res['data']['UploadContractsData']); 
                setClientContractTableHeader(clientContractTableHeader => clientContractTableHeader = res['data']['UploadContractsCols']); 
                // set mastecompanylist for auto complete
                setMasterCompanyList(masterCompanyList => masterCompanyList = res['data']['MasterCompanyList']); 
                // trigger filter 
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter); 
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                // resolve on success
                resolve(res); 
            }).catch(err => {
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false); 
                // reject on error
                reject(); 
            }); 
        }); 
    }

    // refresh function to pass to modals 
    const refreshContractUpload = () => {
        return new Promise((resolve, reject) => {
            // get all data from api 
            getClientContractData().then(res => {
                resolve(res); 
            }).catch(err => {
                reject(err); 
            }); 
        }); 
    }

    // useEffect to run on initial render
    useEffect(() => {
        // get all data from api 
        getClientContractData().then(res => {
            console.log(res); 
        }).catch(err => {
            console.log(err); 
        }); 
        // get entitlement
        if (getAdmin() || getDataTech()){
            setEditButtonBool(editButtonBool => editButtonBool = true); 
        }
        else {
            setEditButtonBool(editButtonBool => editButtonBool = false); 
        }
    }, []); 

    // useEffect to sort client contracts table 
    useEffect(() => {
        // do not run on initial render
        if (!initialRender.current){
            // set status var from dropdown 
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: statusFilter, value: showInactiveContracts, flag: 1, cols: ['active']}, 
                {function: standardSearch, value: contractSearch, flag: 0, cols: ['mastercompanyid', 'companyid', 'filename', 'uploadedby']},
                {function: afterPeriodFilter, value: startPeriodId, flag: 1, cols: ['startperiodid']}, 
                {function: beforePeriodFilter, value: endPeriodId, flag: 1, cols: ['endperiodid']}, 
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(clientContractDataList, functionList);
            // update showDataList
            setShowClientContractDataList(showClientContractDataList => showClientContractDataList = filteredList);
        }
        else{
            initialRender.current = false;
        }
    }, [contractSearch, showInactiveContracts, startPeriodId, endPeriodId, triggerFilter]); 

    const settings = {
        refreshContractUpload, 
        uploadClientContractModal, 
        setUploadClientContractModal,
        showContractCommentModal, 
        setShowContractCommentModal,
        showEditContractModal, 
        setShowEditContractModal,  
        contractUploadRow, 
        setContractUploadRow,
        snackbarAlert,
        showSnackbar, 
        setShowSnackbar,
        snackbarMessage, 
        setSnackbarMessage, 
        snackbarColor, 
        setSnackbarColor,
        masterCompanyList,
    }

    //reset functionality 
    const resetToDefault = () => {
        setStartPeriodId(null);
        setEndPeriodId(null);
        setContractSearch('');
    }

    const enableResetAll = () => {
        if(startPeriodId !== null || endPeriodId !== null || contractSearch !== ''
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [startPeriodId, endPeriodId, contractSearch])


    return (
        <div class='summary-page'>
            {/* wrap children so they have access to variables in PageContext */}
            <PageContext.Provider value={ settings }>
                {/* header and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* modals */}
                <AddClientContractSearchIdModal />
                <ContractUploadCommentModal />
                <EditUploadClientContractModal />
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* top label to view company data */}
                        <div className="p-3 mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap'>
                                <div className='d-flex'>
                                    <div className='pe-3'>
                                        <MonthPicker tag='Start Period' value={startPeriodId} setValue={setStartPeriodId} />
                                    </div>
                                    <div className='pe-3'>
                                        <MonthPicker tag='End Period' value={endPeriodId} setValue={setEndPeriodId} />
                                    </div>
                                    <div className='pe-3'>
                                        <PageInputRedux tag='' value={contractSearch} setValue={setContractSearch}  />
                                    </div>
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${enableReset ? '#0295BE': '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => enableReset ? resetToDefault(): null}>
                                        Reset All
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* table to display company data with links for drilldown */}
                        <div className={`flex-grow-1 ${clientContractDataList.length > 50 ? '' : 'pb-3'}`} style={{ borderRadius: '12px', background: '#fff' }}>

                            <div className="d-flex m-3 align-items-center justify-content-between">
                                <div className='d-flex gap-3 align-items-center'>
                                    <PageDropdownBasic alignContent='left' tag='Contracts' list={contractTypeList}  value={showInactiveContracts} setValue={setShowInactiveContracts} width={'7rem'} />      
                                    <div className= "pe-3 align-self-center text-decoration-underline" style={{color: `${showInactiveContracts===defaultCheckboxDropdownState ? '#BDBDBD': '#0295BE'}`, cursor: 'pointer', fontFamily: 'Roboto medium'}} onClick={() => showInactiveContracts===defaultCheckboxDropdownState ? null:setShowInactiveContracts(defaultCheckboxDropdownState)}>
                                        Reset All
                                    </div>
                                </div>
                                <ButtonComponent tag='Add Client Contract' onButtonClick={() => { setUploadClientContractModal(uploadClientContractModal => uploadClientContractModal = true) }} border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'} width='max-content' />
                                {/* <EntitledButton entitledBool={true} tag='Add Client Contract' cssClass='table-add-button' onClick={() => { setUploadClientContractModal(uploadClientContractModal => uploadClientContractModal = true) }} /> */}
                            </div>
                            <hr style={{ marginTop: 0 }} />
                            <OrderedDataTable RowComponent={UploadContractRowComponent} tableHeader={clientContractTableHeader} dataList={showClientContractDataList} showSpinner={showSpinner} numToPage={50} skeletonHeight='28vh' />
                        </div>
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp"/>
            </PageContext.Provider>
        </div>
    );
}

export default SearchClientContractPage; 